import { SetState, GetState } from 'zustand';
import createBillsHubSlice, { IBillsHubSlice } from '../features/BillsHub/store';

export type IBillPaySlice = IBillsHubSlice;

const createBillPaySlice = (set: SetState<IBillPaySlice>, get: GetState<IBillsHubSlice>) => ({
  ...createBillsHubSlice(set, get),
});

export default createBillPaySlice;
